import { Record } from 'immutable';

export const Address = new Record({
  id:null,
  isNew:true,
  isPending:false,
  place_id : null,
  licence : null,
  osm_type : null,
  osm_id : null,
  lat : null,
  lon : null,
  display_name :null,
  address : null,
  boundingbox: null
});
